import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-hero-glow pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-91">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-92">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-navy-800/50 blur-[120px]" data-id="element-93" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-gold-600/10 blur-[120px]" data-id="element-94" />
        {/* Subtle grid overlay for command center feel */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgc3Ryb2tlPSIjMWUyOTNiIiBzdHJva2Utd2lkdGg9IjAuNSIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTAgNDBoNDBWMHoiLz48L2c+PC9zdmc+')] opacity-20" data-id="element-95" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-96">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start text-left" data-id="element-97">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-navy-800 border border-gold-500/30 text-gold-400 text-sm font-semibold tracking-wider uppercase mb-6" data-id="element-98">
            <span className="w-2 h-2 rounded-full bg-pitch-500 animate-pulse" data-id="element-99" />
            Edición Limitada 2026
          </motion.div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-[1.1] mb-6 uppercase text-balance" data-id="element-100">
            Mundial 2026: <br data-id="element-101" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold-400 to-gold-600" data-id="element-102">
              La Consola de Mando
            </span>
          </h1>

          <h2 className="text-xl sm:text-2xl text-slate-300 font-medium mb-8 text-balance border-l-4 border-gold-500 pl-4" data-id="element-103">
            El Sistema Definitivo de Supervivencia Logística. No dejes el viaje
            de tu vida en manos de la improvisación: domina la logística en 3
            países, 16 sedes y miles de kilómetros sin quebrar tu presupuesto.
          </h2>

          <div className="bg-navy-800/60 border border-navy-700 rounded-xl p-6 mb-8 backdrop-blur-sm" data-id="element-104">
            <p className="text-slate-300 leading-relaxed" data-id="element-105">
              <strong className="text-white font-semibold" data-id="element-106">
                Imagina esto:
              </strong>{' '}
              tienes tus boletos para el partido en Ciudad de México el lunes,
              pero tu siguiente sede es Vancouver el viernes. Tienes que cruzar
              dos fronteras, tres husos horarios y recorrer más de 4,000
              kilómetros en menos de 72 horas. Si tratas el Mundial 2026 como
              unas vacaciones normales, te vas a quedar varado en un aeropuerto
              o pagando $800 dólares por una noche en un motel de carretera.
              Norteamérica es masiva, y la saturación del torneo no perdona a
              los improvisados.
            </p>
          </div>

          <CTAButton data-id="element-107" />
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 30
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative lg:h-[600px] flex items-center justify-center" data-id="element-108">
          {/* Decorative glow behind image */}
          <div className="absolute inset-0 bg-gold-500/20 blur-[100px] rounded-full" data-id="element-109" />

          <motion.img animate={{
          y: [-10, 10, -10]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: 'easeInOut'
        }} src="https://cdn.magicpatterns.com/uploads/pD2ST2tg4ptWMEm7N6cXtM/fifa_2026.png" alt="Mundial 2026: La Consola de Mando - Guía en múltiples dispositivos" className="relative z-10 w-full max-w-lg lg:max-w-none object-contain drop-shadow-2xl" data-id="element-110" />
        </motion.div>
      </div>
    </section>;
}